module.exports = __webpack_public_path__ + "img/nav-design-collectionrings.1660090.webp";